import { render, staticRenderFns } from "./access-token.vue?vue&type=template&id=1cdeda24&scoped=true&"
import script from "./access-token.vue?vue&type=script&lang=js&"
export * from "./access-token.vue?vue&type=script&lang=js&"
import style0 from "./access-token.vue?vue&type=style&index=0&id=1cdeda24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdeda24",
  null
  
)

component.options.__file = "access-token.vue"
export default component.exports